import { FilterInput } from "./types";
import { i18n } from "@/i18n";
const { t } = i18n;

export const filters: FilterInput[] = [
  {
    label: t("filters.studentType"),
    placeholder: t("filters.selectStudentType"),
    name: "studentType",
    type: "DropdownMultiSelect",
    defaultValue: [],
    options: [],
    disableSearch: true,
  },
  {
    label: t("filters.assignedCounselors"),
    placeholder: t("filters.selectCounselors"),
    name: "assignedCounselors",
    type: "DropdownMultiSelect",
    options: [],
    defaultValue: [],
  },
  {
    label: t("filters.funnelState"),
    name: "funnelStates",
    type: "DropdownMultiSelect",
    placeholder: t("filters.selectFunnelState"),
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.major"),
    name: "majors",
    type: "DropdownMultiSelect",
    placeholder: t("filters.selectMajor"),
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.location"),
    name: "location",
    type: "DropdownMultiSelect",
    placeholder: t("filters.selectLocation"),
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.studentSource"),
    name: "studentSource",
    type: "DropdownMultiSelect",
    placeholder: t("filters.selectStudentSource"),
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.interests"),
    name: "interests",
    type: "DropdownMultiSelect",
    placeholder: t("filters.selectInterests"),
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.commitIndex"),
    name: "commitIndex",
    type: "DropdownMultiSelect",
    placeholder: t("filters.selectCommitIndex"),
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.cohortYear"),
    name: "cohortYear",
    type: "DropdownMultiSelect",
    defaultValue: [],
    options: [],
  },
  {
    label: t("filters.entryTerm"),
    name: "entryTerm",
    type: "DropdownMultiSelect",
    defaultValue: [],
    options: [],
  },
];
